import { styledComposition, styleableComposition } from '../../../utils/stylecomponents'
import * as typography from './typography'
import TextareaAutosize from 'react-autosize-textarea'
import Select from 'react-select'
import ReactTooltip from 'react-tooltip'
import FlexAlignCenter from '../FlexAlignCenter'

export const TextareaAutosizeP2 = styledComposition(TextareaAutosize, typography.P2)
export const TextareaAutosizeHint = styledComposition(TextareaAutosize, typography.Hint)

export const SelectH3 = styledComposition(Select, typography.H3)

export const ReactTooltipStyled = styleableComposition(ReactTooltip, typography.Tooltip)`
  line-height: initial;

  ${props => props.raiseAboveModal && `
    && {
      z-index: 2147483647;
    }
  `};

  ${props => props.capitalize && 'text-transform: capitalize'};
`

export const FlexAlignCenterP3 = styledComposition(FlexAlignCenter, typography.P3)
export const FlexAlignCenterCaption1 = styledComposition(FlexAlignCenter, typography.Caption1)
export const FlexAlignCenterCaption6 = styledComposition(FlexAlignCenter, typography.Caption6)
